var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"col-12"},[(!_vm.noLine)?_c('hr'):_vm._e(),_c('label',{staticClass:"mb-1"},[_vm._v(_vm._s(_vm.title))]),_c('small',{staticClass:"form-text text-muted"},[_vm._v(_vm._s(_vm.description))])])
}
var staticRenderFns = []

export { render, staticRenderFns }